export default __webpack_public_path__ + "static/media/trash-bin.e9adb883.svg";